"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var components_1 = require("../../components");
exports.withIcons = function (Component) { return function (props) {
    var leftIcon = props.leftIcon, rightIcon = props.rightIcon, rest = __rest(props, ["leftIcon", "rightIcon"]);
    return (React.createElement("div", { className: "with-icons" },
        leftIcon && React.createElement(components_1.Icon, { className: "icon-left", icon: leftIcon }),
        React.createElement(Component, __assign({}, rest)),
        rightIcon && React.createElement(components_1.Icon, { className: "icon-right", icon: rightIcon })));
}; };
exports.default = exports.withIcons;
//# sourceMappingURL=withIcons.js.map


//////////////////
// WEBPACK FOOTER
// ../player-textbox/build/control/hocs/common/withIcons.js
// module id = 145
// module chunks = 0 1 2